import { render, staticRenderFns } from "./user_show.vue?vue&type=template&id=65177316&"
import script from "./user_show.vue?vue&type=script&lang=js&"
export * from "./user_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports